var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 165,
    viewBox: "0 0 503 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.059 127.276V0H122.846V127.276H131.059Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.496 84.968C152.496 110.529 170.53 129.391 194.992 129.391C219.454 129.391 237.488 110.529 237.488 84.968C237.488 59.4071 219.454 40.5449 194.992 40.5449C170.53 40.5449 152.496 59.4071 152.496 84.968ZM160.888 84.968C160.888 63.2853 174.993 47.9487 194.992 47.9487C214.99 47.9487 229.096 63.2853 229.096 84.968C229.096 106.651 214.99 121.987 194.992 121.987C174.993 121.987 160.888 106.651 160.888 84.968Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.712 82.3237C251.712 104.712 266.175 124.103 290.816 124.103C306.35 124.103 319.027 116.17 324.92 102.596V125.513C324.92 144.728 312.242 157.596 293.315 157.596C276.888 157.596 265.282 148.958 262.068 134.151H254.033C257.604 153.542 272.424 165 293.137 165C317.063 165 332.954 149.135 332.954 125.513V42.6603H326.348L325.277 62.4038C319.563 48.3013 307.6 40.5449 291.708 40.5449C266.354 40.5449 251.712 59.9359 251.712 82.3237ZM260.104 82.3237C260.104 63.8141 271.353 47.9487 291.708 47.9487C312.242 47.9487 323.491 62.5801 323.491 82.1474C323.491 102.067 311.706 116.699 291.351 116.699C271.532 116.699 260.104 101.01 260.104 82.3237Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.862 163.061C354.433 163.766 357.825 164.119 362.468 164.119C374.074 164.119 381.93 159.006 386.394 146.843L424.426 42.6603H416.034L387.108 121.987L356.932 42.6603H348.362L383.18 133.093L378.895 144.551C374.431 156.538 365.86 156.538 358.897 156.538H350.862V163.061Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.792 127.276L466.218 90.7853L493.001 127.276H503L471.932 84.968L503 42.6603H493.18L466.575 78.9744L439.97 42.6603H429.971L460.861 84.6154L429.793 127.276H439.792Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.946999L27.8825 16.8401V100.533L0 84.6399V0.946999Z",
    fill: "#3FA34D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3355 127.011H87.849V101.558H29.6802L74.3355 127.011Z",
    fill: "#3FA34D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1772 108.164L0 127.325H15.1178L23.1478 114.418L12.1772 108.164Z",
    fill: "#3FA34D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7304 69.9262L48.7531 88.7383L38.1469 82.6927L45.9581 69.9262H60.7304Z",
    fill: "#3FA34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2b0d5bc8c70fd769bb9ec76540b0e85.svg";
export { ForwardRef as ReactComponent };